import {useEffect, useState} from 'react';

export const useLocalStorage = (key: string, initialValue: string | null) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      if (storedValue) window.localStorage.setItem(key, JSON.stringify(storedValue));
      else window.localStorage.removeItem(key);
    } catch (error) {
      evite.error(error);
    }
  }, [key, storedValue]);

  const removeValue = () => {
    window.localStorage.removeItem(key);
    setStoredValue(initialValue);
  };

  return [storedValue, setStoredValue, removeValue];
};
